import React from 'react'
import LocationBanner from '../../components/location/locationBanner'
import Header from "../../shared/header"
import PagesFooter from "../../shared/pagesFooter"
const LocationPage = () => {
    return (
        <div>
            <div className='location-header'>
                <Header />
            </div>
            <LocationBanner />
            <PagesFooter />
        </div>
    )
}

export default LocationPage